import React from 'react';

import { GetawayDetailsWrapper } from '@components';
import { scrollTop } from '@share/utils';

import './style.scss';

interface IProps {}

export class GetawayDetailsPage extends React.Component<IProps, null> {
  constructor(props: IProps) {
    super(props);

    scrollTop();
  }

  render(): React.ReactNode {
    return <GetawayDetailsWrapper />;
  }
}
